import React, { ReactElement, useState } from "react";
import { makeStyles, Button } from "@material-ui/core";
import theme from "../../themes";
import VideoIcon from "../../images/lets-icons_video.png";
import ComingSoonDialog from "./ComingSoonDialog";

const useStyles = makeStyles(() => ({
  buttonContainer: {
    display: "flex",
  },
  exportButton: {
    fontFamily: "'DM Sans', sans-serif",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "14px",
    lineHeight: "150%",
    backgroundColor: "#FFFFFF",
    color: theme.palette.primary.main,
    borderRadius: "8px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textTransform: "uppercase",
    padding: "10px 20px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "15px",
    },
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  dialogPaper: {
    borderRadius: "20px",
    maxWidth: "900px",
    width: "900px",
    position: "relative" as const,
    overflow: "visible",
    padding: "20px",
    backgroundColor: "#E6E6E6",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "95%",
      width: "95%",
    },
  },
  closeButton: {
    position: "absolute" as const,
    right: "10px",
    top: "10px",
    backgroundColor: "#ED1C24",
    color: "white",
    width: "32px",
    height: "32px",
    padding: 0,
    zIndex: 1,
    "&:hover": {
      backgroundColor: "#D41920",
    },
  },
  videoContainer: {
    position: "relative" as const,
    width: "100%",
    height: "500px",
    backgroundColor: "white",
    borderRadius: "10px",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      height: "300px",
    },
  },
}));

const VideoTutorialButton = ({
  label = "WATCH TUTORIALS",
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  tutorialUrl,
}: {
  label?: string;
  tutorialUrl: string;
}): ReactElement => {
  const classes = useStyles();

  const [comingSoonOpen, setComingSoonOpen] = useState(false);

  return (
    <div className={classes.buttonContainer} style={{ padding: 0, margin: 0 }}>
      <ComingSoonDialog
        open={comingSoonOpen}
        onClose={() => setComingSoonOpen(false)}
        useInfoIcon
        maxWidth="560px"
        title="COMING SOON!"
        subtitle="Watch Tutorials to Get Started"
        description="Learn how to use all the features of the Chamber Perks App™ to attract and retain members, help your members grow their networks and increase sales, and generate non-dues revenue for your chamber while boosting engagement."
      />
      <Button
        size="large"
        variant="contained"
        className={classes.exportButton}
        onClick={() => setComingSoonOpen(true)}
      >
        <img
          src={VideoIcon}
          alt="video"
          style={{
            marginRight: "10px",
            width: "24px",
            height: "24px",
          }}
        />
        {label}
      </Button>
    </div>
  );
};

export default VideoTutorialButton;
